import { SpellSlot } from '../atoms/SpellSlot';

/**
 * In-game hotbar showing the 4 equipped spells.
 * Primary keys: 1–4 (WASD scheme)  ·  Alt keys: Z/X/C/V (arrow-key scheme)
 * Greys out each spell with a countdown while on cooldown.
 */
export function SpellHotbar({ equippedSpells, spellCooldowns, onCast }) {
  return (
    <div className="spell-hotbar">
      {equippedSpells.map((spellId, i) => (
        <SpellSlot
          key={i}
          index={i}
          spellId={spellId}
          spellCooldowns={spellCooldowns}
          onCast={onCast}
        />
      ))}
    </div>
  );
}
